import React, { useState } from "react";
import {
  Container,
  InputLabel,
  Box,
  FormControl,
  Select,
  MenuItem,
  AlertTitle,
  Alert,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import CssBaseline from "@mui/material/CssBaseline";
import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fileReportDownload } from "../../../utils/fileReportDownload";
import { dateToFormat } from "../../../utils/dateParsing";
import es from "date-fns/locale/es";

const REPORTS_TYPE = [
  { name: 'Atenciones', url: '/subred_norte_bogota_xls_export/attentions', file: 'atenciones' },
  { name: 'Insumos TAB', url: '/subred_norte_bogota_xls_export/supplies_tab', file: 'insumos-tab' },
  { name: 'Insumos TAM', url: '/subred_norte_bogota_xls_export/supplies_tam', file: 'insumos-tam' },
  { name: 'Medicamentos de control TAM', url: '/subred_norte_bogota_xls_export/control_medicines_tam', file: 'medicamentos-control-tam' },
  { name: 'Medicamentos TAM', url: '/subred_norte_bogota_xls_export/medicines_tam', file: 'medicamentos-tam' },
  { name: 'Furtran', url: '/subred_norte_bogota_xls_export/furtran', file: 'furtran' },
  { name: 'Reporte de tiempos', url: '/subred_norte_bogota_xls_export/time_report', file: 'reporte-tiempos' },
  { name: 'Total despacho por ambulancia', url: '/subred_norte_bogota_xls_export/dispatch_ambulance', file: 'total-despachos-ambulancia' },
  { name: 'Desinfección PDF', url: '/aph_bogota_norte_pdf/disinfection_report', file: 'desinfeccion', showAmbulanceField: true, isPDF:true },
  { name: 'Humedad relativa PDF', url: '/aph_bogota_norte_pdf/relative_humidity_report', file: 'humedad-relativa', showAmbulanceField: true, isPDF:true },

];

const AMBULANCE_LIST = [
  "JQV226",
  "JQV151",
  "LIS775",
  "LIS762",
  "LIS764",
  "JQV106",
  "JQV224",
  "JQV225",
  "LIS776",
  "JQV104",
  "JQV103",
  "JQV100",
  "JQV099",
  "JQV101",
  "JQV102",
  "JQV105",
  "JQV107",
  "JQV108",
  "JQV109",
  "JQV110",
  "JQV111",
  "JQV112",
  "JQV113",
  "JQV114",
  "JQV115",
  "JQV116",
  "JQV117",
  "JQV248",
  "JQV227",
  "JQV245",
  "JQV246",
  "JQV247",
  "JQV249",
  "OLN319",
  "OLN297",
];

export const APHNorteReport = () => {
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [ambulanceSelected, setAmbulanceSelected] = useState('');
  const [filterType, setFilterType] = useState(REPORTS_TYPE[0]);
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertInfo, setAlertInfo] = useState({});

  registerLocale("es", es);

  const handleSubmit = (event) => {
    event.preventDefault();
    requestReport();
  };

  const requestReport = async () => {
    try {
      const params = {
        fromDate: dateToFormat(fromDate, 'YYYY/MM/DD HH:mm'),
        untilDate: dateToFormat(toDate, 'YYYY/MM/DD HH:mm'),
        ambulance: ambulanceSelected
      }
      setShowAlert(false);
      setLoading(true);
      const extention = filterType.isPDF?'pdf':'xlsx'
      await fileReportDownload(filterType.url, params, `${filterType.file}.${extention}`,filterType.isPDF);
      setLoading(false);
    } catch (error) {
      console.log("error -> ", error);
      if (error.response.status === 406) { //range bad
        setAlertInfo({
          title: "Error",
          message: "Rango de fecha excedido",
          action: "Cambia el rango de fechas",
        });
        setShowAlert(true);
      } else if (error.response.status === 400) { // rango no válido
        setAlertInfo({
          title: "Error",
          message: "El rango de fecha no es válido",
          action: "Valida que el rango sea correcto",
        });
        setShowAlert(true);
      } else if (error.response.status === 0) {
        setAlertInfo({
          title: "Timeout",
          message: "Ocurrio un error procesando",
          action: "Intenta reduciendo el rango de fechas",
        });
        setShowAlert(true);
      } else {
        setAlertInfo({
          title: "Error del servidor",
          message: "Ocurrio un error procesando",
          action: "Intenta reduciendo el rango de fechas",
        });
        setShowAlert(true);
      }
      setLoading(false);
    }
  };

  const handleChangeSelect = (event) => {
    event.preventDefault();
    setFilterType(event.target.value);
  };

  const handleChangeAmbulanceSelect = (event) => {
    event.preventDefault();
    setAmbulanceSelected(event.target.value)
  };

  return (
    <Container component="main" maxWidth="sm">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
        }}
      >
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          {showAlert && (
            <Alert onClose={() => setShowAlert(false) } severity="error">
              <AlertTitle>{alertInfo?.title}</AlertTitle>
              {alertInfo?.message} — <strong>{alertInfo?.action}</strong>
            </Alert>
          )}

          <InputLabel>Desde</InputLabel>
          <div style={{ display: "flex", marginBottom: 10 }}>
            <DatePicker
              dateFormat="yyyy/MM/dd HH:mm"
              selected={fromDate}
              onChange={setFromDate}
              showTimeSelect
              name="fromDate"
              locale="es"
              className="react-datetimepicker-custom"
            />
          </div>

          <InputLabel>Hasta</InputLabel>
          <div style={{ display: "flex" }}>
            <DatePicker
              dateFormat="yyyy/MM/dd HH:mm"
              selected={toDate}
              onChange={setToDate}
              showTimeSelect
              name="toDate"
              locale="es"
              className="react-datetimepicker-custom"
            />
          </div>

          <br />
          <FormControl fullWidth>
            <InputLabel id="filtertype-select-label">Filtrar Por</InputLabel>
            <Select
              labelId="filtertype-select-label"
              id="filtertype-select"
              value={filterType}
              label="filterType"
              onChange={handleChangeSelect}
              name="filtertype-select"
            >
              {
                REPORTS_TYPE.map((item, key) => <MenuItem key={key} value={item}>{item.name}</MenuItem> )
              }
            </Select>
          </FormControl>

          {
            filterType.showAmbulanceField ?
            <>
              <br/>
              <br/>
              <FormControl fullWidth>
                <InputLabel id="filtertype-ambulance-label">Seleccione la placa</InputLabel>
                <Select
                  labelId="filtertype-ambulance-label"
                  id="filtertype-ambulance"
                  value={ambulanceSelected}
                  label="Seleccione la placa"
                  onChange={handleChangeAmbulanceSelect}
                  name="filtertype-ambulance"
                >
                  {
                    AMBULANCE_LIST.map((item, key) => <MenuItem key={key+item} value={item}>{item}</MenuItem>)
                  }
                </Select>
              </FormControl>
            </>
              : null
          }

          <LoadingButton
            type="submit"
            fullWidth
            loading={loading}
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Generar Reporte
          </LoadingButton>
        </Box>
      </Box>
    </Container>
  );
};
